import React from "react";
import DateDisplay from "../../../DateDisplay";
import { ThemedIcon, ThemedSpan } from "../../../utilities";
import ReviewSectionStatus from "./ReviewSectionStatus";
import { Popover } from "react-bootstrap";
import ConditionalPopover from "../../../utilities/ConditionalPopover";
import styled from "styled-components";
import moment from "moment";
import classNames from "classnames";

const LargePopover = styled(Popover)`
    max-width: 500px;
`;

const ReviewSummaryCard = ({ data, isActive }) => {
   
    const { 
        reviewId,
        reviewDate,
        reviewStatusComment,
        reviewAdviser,
        reviewStatusText,
        verificationRequired,
        verificationStatusText,
        verificationStatusComment,
        verificationScore,
        verificationTargetDate,
        verifiedDate,
        verifiedBy,
        isDrawdownReview,
        drawdownVerifiedByUser,
        drawdownVerifiedDate,
        drawdownStatusText,
        drawdownStatusComment,
        drawdownTarget,
        preReviewDocumentRequired,
        preReviewDocumentSentDate,
        preReviewDocumentStatusText,
        preReviewDocumentAuthor,
        preReviewDocumentStatusComment,
        appointmentRequired,
        appointmentScheduledBy,
        appointmentScheduledDate,
        appointmentStatusText,
        appointmentDate,
        appointmentStyleText,
        appointmentScheduledTargetDate,
        appointmentScore,
        appointmentStatusComment,
        meetingNoteRequired,
        meetingNoteStatusText,
        meetingNotesUpdatedBy,
        meetingNotesUpdatedDate,
        meetingNoteStatusComment,
        followUpAuthor,
        followUpReportStatusText,
        followUpRequired,
        followUpSentDate,
        followUpStatusComment,
        delayed,
        preReviewDocumentScore,
        preReviewDocumentTargetDate,
        meetingNotesScore,
        meetingNotesUpdatedTargetDate,
        followUpScore,
        followUpSentTargetDate,
        clientServiceLevelAgreement : { serviceLevelAgreement : { serviceName }}
    } = data;


    var activeReviewClass = classNames({
        card: true,
        'border-success': isActive,
    });

    return (
        <div className="p-3" key={reviewId}>
            <div className={activeReviewClass}>
                <div className="card-body">
                    <div className="row mb-2">
                    <ConditionalPopover
                        condition={reviewStatusComment != null && reviewStatusComment !== ""}
                        placement="top"
                        popover={<LargePopover>
                                        <Popover.Body>
                                            <div style={{ textAlign: "left" }}>
                                                <span>{reviewStatusComment}</span>
                                            </div>
                                        </Popover.Body>
                                    </LargePopover>
                                }
                        >
                            <div className="col-11">
                                <div className="row">
                                    <div className="col-3">
                                        <ThemedSpan variant="primary"><DateDisplay format="DD/MM/YYYY">{reviewDate}</DateDisplay></ThemedSpan>
                                        <br/>
                                        <div className="row mb-2">
                                            <div className="col">
                                                <span className="fs-6 text-muted fst-italic">{reviewStatusText}</span>
                                            </div> 
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <ThemedSpan variant="primary">{reviewAdviser}</ThemedSpan>
                                    </div>
                                    <div className="col-4">
                                        <ThemedSpan variant="primary">{serviceName ?? "Not Found"}</ThemedSpan>
                                    </div>
                                </div>
                            </div>
                    </ConditionalPopover>                  
                            {(delayed || reviewStatusText === "Cancelled" || followUpSentDate === null) && <div className="col-1">
                                    <ThemedIcon icon="fa-triangle-exclamation" size="2x" variant="warning" />
                                </div>
                            }
                        </div>
                        
                    <ReviewSectionStatus 
                        isRequired={verificationRequired} 
                        label="Portfolio Verification" 
                        status={verificationStatusText}
                        verifiedDate={verifiedDate}
                        verifiedBy={verifiedBy}
                        statusComment={verificationStatusComment}
                        reviewDate={reviewDate}
                        previousComplete={true}
                        score={verificationScore}
                        targetDate={verificationTargetDate}
                    />
                    <ReviewSectionStatus 
                        isRequired={preReviewDocumentRequired} 
                        label="PRD" 
                        status={preReviewDocumentStatusText}
                        verifiedDate={preReviewDocumentSentDate}
                        verifiedBy={preReviewDocumentAuthor}
                        statusComment={preReviewDocumentStatusComment}
                        reviewDate={reviewDate}
                        previousComplete={verifiedDate != null}
                        score={preReviewDocumentScore}
                        targetDate={preReviewDocumentTargetDate}
                    />
                     <ReviewSectionStatus 
                        isRequired={appointmentRequired} 
                        label="Appointment" 
                        status={appointmentStatusText}
                        verifiedDate={appointmentScheduledDate}
                        verifiedBy={appointmentScheduledBy}
                        statusComment={appointmentStatusComment}
                        reviewDate={reviewDate}
                        previousComplete={preReviewDocumentSentDate != null}
                        score={appointmentScore}
                        targetDate={appointmentScheduledTargetDate}
                    />
                    <ReviewSectionStatus 
                        isRequired={meetingNoteRequired} 
                        label="Meeting Notes" 
                        status={meetingNoteStatusText}
                        verifiedDate={meetingNotesUpdatedDate}
                        verifiedBy={meetingNotesUpdatedBy}
                        statusComment={meetingNoteStatusComment}
                        reviewDate={reviewDate}
                        previousComplete={appointmentDate != null &&
                                            moment(appointmentDate).isBefore()}
                        score={meetingNotesScore}
                        targetDate={meetingNotesUpdatedTargetDate}
                    />
                    <ReviewSectionStatus 
                        isRequired={followUpRequired} 
                        label="Follow Up" 
                        status={followUpReportStatusText}
                        verifiedDate={followUpSentDate}
                        verifiedBy={followUpAuthor}
                        statusComment={followUpStatusComment}
                        reviewDate={reviewDate}
                        previousComplete={meetingNotesUpdatedDate != null}
                        score={followUpScore}
                        targetDate={followUpSentTargetDate}
                    /> 
                </div>
            </div>
        </div>
    );
};

export default ReviewSummaryCard;